<template>
  <div class="map-pc">
    <div class="amap-wrapper" style="width:100%; height: 40vh">
      <el-amap
        ref="map"
        :amap-manager="amapManager"
        :center="center"
        :zoom="zoom"
        :events="events"
        :plugin="plugin"
        class="amap-box"
      ></el-amap>
    </div>
    <div class="btn-area">
      <van-cell @click="show = true" title="地图队伍筛选" is-link :value="current" />
    </div>
    <div class="arrive_list">
      <div class="head">
        <img src="../../assets/arrive-head.png" />
      </div>
      <div class="body">
        <div v-for="(group, index) in l_time_list" :key="index" class="item" :class="`${index % 2 == 0 ? 'even' : ''}`">
          <div class="info">
            <div class="g-name">{{ group.unit }}</div>
            <div class="g-num">{{ group.ename }}</div>
          </div>
          <div class="l-time">{{ group.l_time | time }}</div>
        </div>
      </div>
      <div class="footer">*以上信息仅供参考，以现场实际信息为准</div>
    </div>
    <van-popup position="bottom" v-model="show">
      <van-picker show-toolbar title="筛选队伍" :columns="t_list" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import map_icon from '../../assets/map-icon.png'
import { getMapData3 } from '@/libs/api.js'
import { line, linex, cp0, cp1, cp2 } from './line.mini.js'

import { AMapManager } from 'vue-amap'
let amapManager = new AMapManager()

let loading = false

const mark_a = process.env.BASE_URL + 'map_icon/mark_a.png'
const mark_b = process.env.BASE_URL + 'map_icon/mark_b.png'

export default {
  filters: {
    time(val) {
      if (!val) return '--分--秒'
      val = new Date(val)
      let h = val.getHours()
      let m = val.getMinutes()
      if (isNaN(h) || isNaN(m)) {
        return '--分--秒'
      }
      return h + '时' + m + '分'
    },
  },
  mounted() {
    let self = this
  },
  data() {
    let self = this
    return {
      show: false,
      current: '全部',
      first: false,
      show_list: [],
      l_time_list: [],
      t_list: ['全部'],
      p_list: [],
      list: [],
      amapManager,
      center: [121.213164, 31.055582],
      zoom: 12,
      events: {
        init: (o) => {
          self.amapManager = o
          var polyline = new AMap.Polyline({
            map: o,
            path: line,
            showDir: true,
            strokeColor: '#28F', //线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6, //线宽
            // strokeStyle: "solid"  //线样式
          })

          o.setFitView()
          // o.setMapStyle("amap://styles/db0aae9736c55cc8d4379cedce535e0b");

          self.get_map_data()
          setInterval(() => {
            self.get_map_data()
          }, 5000)
        },
        // 地图点击事件
        click: (e) => {},
      },
      plugin: [],
    }
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    if (this.amapManager) {
      Object.values(this.p_list).forEach(({ marker }) => {
        marker.setMap(null);
      });
      this.amapManager.destroy();
    }
  },
  methods: {
    onCancel() {
      this.show = false
    },
    onConfirm(e) {
      Object.keys(this.p_list).forEach((key) => {
        if (e == '全部') {
          this.p_list[key].marker.show()
        } else {
          if (key == 'A' + e || key == 'B' + e) {
            this.p_list[key].marker.show()
          } else {
            this.p_list[key].marker.hide()
          }
        }
      })
      this.current = e
      this.show = false
    },
    create_marker(scorename, position) {
      const self = this
      let icon_url = mark_a
      let class_name = 'mark_a'
      if (scorename.slice(0, 1) == 'B') {
        icon_url = mark_b
        class_name = 'mark_b'
      }

      return new AMap.Marker({
        icon: icon_url,
        map: self.amapManager,
        position: position || cp0,
        autoRotation: true,
        angle: -90,
        label: {
          content: `<div class="${class_name}">${scorename}</div>`,
          offset: new AMap.Pixel(-8, -24),
          direction: 'center',
        },
      })
    },
    get_map_data() {
      loading = true
      getMapData3(this.$route.query)
        .then((r) => {
          let self = this
          if (r.status == 200) {
            this.list = r.data.list
            let p_list = {}
            this.l_time_list = []
            r.data.list.forEach((row, index) => {
              // 即将抵达列表数据
              if (!(row.cpname == 'cp0' && (row.chipid2 || row.statenumber == 1))) {
                let l_time
                let i = null
                switch (row.cpname) {
                  case 'cp0':
                    l_time = 0.6 / row.speed
                    break
                  case 'cp1':
                    l_time = 2 / row.speed
                    break
                  case 'cp3':
                    l_time = 6.5 / row.speed
                    break
                  case 'cp4':
                    l_time = 1 / row.speed
                    break
                  case 'cp2':
                    l_time = 6.5 / row.speed
                    break
                }

                l_time = l_time * 3600000 + row.time * 1

                this.l_time_list.push({
                  ename: row.ename,
                  groupname: row.groupname,
                  unit: row.unit,
                  l_time,
                })
              }

              let i = 1
              switch (row.cpname) {
                case 'cp0':
                  i = 1;
                  break;
                case 'cp1':
                  i = 2;
                  break;
                case 'cp3':
                  i = 3;
                  break;
                case 'cp2':
                  i = 4;
                  break;
                case 'cp4':
                  i = 5;
                  break;
              }

              if (!this.first) {
                let team = this.t_list.find((item) => {
                  return item == row.scorename.slice(1)
                })
                if (!team) {
                  this.t_list.push(row.scorename.slice(1))
                }
              }

              // 判断是否完赛
              if (row.speed == 0) {
                console.log('完赛')
                // 剩余时间逻辑

                // 地图逻辑
                let marker
                if (this.p_list[row.scorename]) {
                  marker = this.p_list[row.scorename].marker
                  marker.stopMove()
                  marker.setPosition(cp0)
                } else {
                  marker = self.create_marker(row.scorename)

                  if (!this.p_list[row.scorename]) {
                    this.p_list[row.scorename] = {}
                  }
                  this.p_list[row.scorename].marker = marker
                }
              } else {
                if (this.p_list[row.scorename]) {
                  // 本地存在这个队伍的数据

                  // 地图逻辑
                  if (this.p_list[row.scorename].i != i) {
                    // 经过下一个cp点
                    console.log(row.scorename + '经过下一个cp点')
                    let marker = this.p_list[row.scorename].marker
                    // 停止动画
                    marker.stopMove()
                    // 开始下一段路线动画

                    new AMap.Polyline({
                      path: linex['line' + i][0].left_line,
                      showDir: true,
                      strokeColor: '#28F', //线颜色
                      // strokeOpacity: 1,     //线透明度
                      strokeWeight: 6, //线宽
                      // strokeStyle: "solid"  //线样式
                    })

                    let l = [...linex['line' + i][0].left_line].concat()

                    marker.moveAlong(l, row.speed)
                    // 配置cpname
                    this.p_list[row.scorename].cpname = row.cpname
                    this.p_list[row.scorename].i = i
                  } else {
                    // 数据无变化
                    console.log('数据无变化')
                  }
                  p_list = this.p_list
                } else {
                  // 第一次出现

                  // 地图逻辑
                  p_list = this.p_list
                  p_list[row.scorename] = {}

                  console.log('第一次取到数据, 画点' + row.scorename)
                  p_list[row.scorename].cpname = row.cpname
                  let p_line = self.set_line({
                    speed: row.speed,
                    time: row.time,
                    systime: r.data.systime,
                    cpname: row.cpname,
                    lastcpname: row.lastcpname,
                    i
                  })
                  let marker = null

                  if (p_line.length > 1) {
                    marker = self.create_marker(row.scorename)

                    let l = [...p_line].concat()

                    marker.moveAlong(l, row.speed)
                  } else if (p_line.length == 1) {
                    marker = self.create_marker(row.scorename, linex['line' + (i + 1)][0].point)
                  }

                  p_list[row.scorename].marker = marker
                  p_list[row.scorename].i = i
                }
              }
            })
            console.log('--------')

            this.l_time_list.sort((a, b) => {
              return a.l_time - b.l_time
            })

            this.l_time_list = this.l_time_list.slice(0, 6)

            self.$nextTick(() => {
              self.p_list = p_list
              if (!self.first) {
                self.t_list.sort((a, b) => {
                  return a * 1 - b * 1
                })
                self.first = true
              }
            })
          } else {
          }
          loading = false
        })
        .catch((err) => {
          loading = false
          console.error(err, 111)
        })
    },
    set_line(params) {
      let time = params.systime * 1000 - params.time
      let dis = params.speed * (time / 3600)

      let item_line = linex['line' + params.i]

      return this.get_index(item_line, dis)
    },
    get_index(arr, dis) {
      let index
      let self = this
      let item = arr.find((item, index) => {
        return dis <= item.distance
      })

      if (item) {
        new AMap.Polyline({
          path: item.left_line,
          showDir: true,
          strokeColor: '#28F', //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6, //线宽
          // strokeStyle: "solid"  //线样式
        })
        return item.left_line
      } else {
        return arr[arr.length - 1].left_line
      }
    },
  },
}
</script>

<style lang="less" scoped>
.map-pc {
  /deep/ .amap-marker-label {
    padding: 0;
    border: none;
    .mark_a {
      border: 1px solid #c5141e;
      padding: 4px;
      background: #fff;
    }
    .mark_b {
      border: 1px solid blue;
      padding: 4px;
      background: #fff;
    }
  }
  .arrive_list {
    border-top: 1px solid #eee;
    min-height: 60vh;
    background-color: #c5141e;
    position: relative;
    padding-bottom: 100px;
    .head {
      margin-bottom: 30px;
      img {
        width: 100%;
      }
    }
    .body {
      .item {
        padding: 10px 20px 10px 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.even {
          background: #b1111a;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
        }
        .info {
          color: #fff;
          font-size: 20px;
          .g-name {
            font-weight: bold;
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .l-time {
          font-size: 20px;
          color: #fff;
        }
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 10px 0;
      text-align: center;
      background: #fff;
      color: #a31119;
      font-size: 12px;
    }
  }
}
</style>
